import { requestConstants } from '../constants/request.constants';
import requestService from '../services/request.service';
import { alertActions } from './alert.actions';
import { history } from '../helpers';
import { b64toBlob } from '../helpers/base64';

export const requestActions = {
  create,
  update,
  remove,  
  fetch,  
  get,
  approve,
  approvePending,
  reject
};

function create (obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const request = await requestService.create(obj);
      dispatch(success(request));
      
      if (request.Status === 2) {
        dispatch(alertActions.success('Solicitação criada e aprovada automaticamente.'));
      } else {
        dispatch(alertActions.success('Solicitação criada.'));
      }
      history.push('/requests');
    } catch(error) {            
      dispatch(alertActions.error(error));      
      dispatch(failure(error));      
    }
  };

  function request() { return { type: requestConstants.CREATE_REQUEST } }
  function success(request) { return { type: requestConstants.CREATE_SUCCESS, request } }
  function failure(error) { return { type: requestConstants.CREATE_FAILURE, error } }
}

function update (id, obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const request = await requestService.update(id, obj);
      dispatch(success(request));
      dispatch(alertActions.success('Solicitação alterada'));
      history.push('/requests');
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: requestConstants.UPDATE_REQUEST } }
  function success(request) { return { type: requestConstants.UPDATE_SUCCESS, request } }
  function failure(error) { return { type: requestConstants.UPDATE_FAILURE, error } }
}

function remove (id) {
  return async dispatch => {
    dispatch(request(id));
    try {
      const request = await requestService.remove(id);
      dispatch(success(request));
      dispatch(alertActions.success("Solicitação removida"));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: requestConstants.REMOVE_REQUEST } }
  function success(request) { return { type: requestConstants.REMOVE_SUCCESS, request } }
  function failure(error) { return { type: requestConstants.REMOVE_FAILURE, error } }
}

function fetch(params) {
  return async dispatch => {
    dispatch(request());
    try {
      const requests = await requestService.fetch(params);
      if (params.export && requests.file) {        
        const blob = b64toBlob(requests.file, {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        var csvURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', 'solicitacoes-hora.xlsx');
        tempLink.click();
      }
      dispatch(success(requests));
    } catch(error) {      
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: requestConstants.FETCH_REQUEST } }
  function success(requests) { return { type: requestConstants.FETCH_SUCCESS, requests } }
  function failure(error) { return { type: requestConstants.FETCH_FAILURE, error } }
}

function get (id) {
  return async dispatch => {
    dispatch(request(id));
    try {
      const request = await requestService.get(id);
      dispatch(success(request));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: requestConstants.GET_REQUEST } }
  function success(request) { return { type: requestConstants.GET_SUCCESS, request } }
  function failure(error) { return { type: requestConstants.GET_FAILURE, error } }
}

function approve(id, approvalCategory) {  
  return async dispatch => {
    dispatch(request(id));
    try {
      const request = await requestService.approve(id, approvalCategory);
      dispatch(success(request));
      dispatch(alertActions.success("Solicitação aprovada"));          
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: requestConstants.APPROVE_REQUEST } }
  function success(request) { return { type: requestConstants.APPROVE_SUCCESS, request } }
  function failure(error) { return { type: requestConstants.APPROVE_FAILURE, error } }
}

function approvePending(approvalCategory) {
  return async dispatch => {
    dispatch(request());
    try {
      const request = await requestService.approvePending(approvalCategory);
      dispatch(success(request));
      dispatch(alertActions.success("Solicitações Aprovadas"));          
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: requestConstants.APPROVE_REQUEST } }
  function success(request) { return { type: requestConstants.APPROVE_SUCCESS, request } }
  function failure(error) { return { type: requestConstants.APPROVE_FAILURE, error } }
}

function reject (id, comment) {
  return async dispatch => {
    dispatch(request(id));
    try {
      const request = await requestService.reject(id, { comment });
      dispatch(success(request));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: requestConstants.REJECT_REQUEST } }
  function success(request) { return { type: requestConstants.REJECT_SUCCESS, request } }
  function failure(error) { return { type: requestConstants.REJECT_FAILURE, error } }
}